import { useEffect, useState } from "react";
import { FilePlus2, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const FORMATS = [
  ["pdf", "PDF"], ["docx", "Word (.docx)"], ["doc", "Word 97-2003 (.doc)"], ["pptx", "Slides (.pptx)"], ["ppt", "Slides 97-2003 (.ppt)"],
  ["xlsx", "Excel (.xlsx)"], ["xls", "Excel 97-2003 (.xls)"], ["csv", "CSV"], ["txt", "Plain text"], ["md", "Markdown"], ["html", "Web page (.html)"], ["rtf", "Rich text (.rtf)"], ["odt", "OpenDocument (.odt)"],
];

export function MakeDocumentButton({ onMake, disabled, trigger = 0, hideButton = false }) {
  const [open, setOpen] = useState(false);
  const [format, setFormat] = useState("pdf");
  const [request, setRequest] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (trigger) setOpen(true); }, [trigger]);
  const submit = async () => {
    setBusy(true);
    const ok = await onMake({ format, request: request.trim() });
    setBusy(false);
    if (ok !== false) { setOpen(false); setRequest(""); }
  };
  return (
    <>
      {!hideButton && <button onClick={() => setOpen(true)} disabled={disabled} data-testid="make-document-btn" title="Make a document"
        className="h-9 w-9 rounded-xl flex items-center justify-center text-neutral-400 hover:text-white hover:bg-white/10 transition-colors disabled:opacity-40">
        <FilePlus2 className="h-4 w-4" />
      </button>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#121725] border-white/10 text-white" data-testid="make-document-dialog">
          <DialogHeader>
            <DialogTitle>Make a document</DialogTitle>
            <DialogDescription className="text-neutral-400">Built from this chat and your uploaded files. Uses 1 message.</DialogDescription>
          </DialogHeader>
          <label className="text-xs text-neutral-400">Format</label>
          <select value={format} onChange={(e) => setFormat(e.target.value)} data-testid="make-document-format"
            className="w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm outline-none focus:border-sky-400/50">
            {FORMATS.map(([v, l]) => <option key={v} value={v} className="bg-[#121725]">{l}</option>)}
          </select>
          <label className="text-xs text-neutral-400">What should it contain?</label>
          <textarea rows={3} value={request} onChange={(e) => setRequest(e.target.value)} data-testid="make-document-request"
            placeholder="e.g. A one-page revision sheet on photosynthesis with a key-terms table"
            className="w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm outline-none focus:border-sky-400/50 resize-none" />
          <button onClick={submit} disabled={busy} data-testid="make-document-submit"
            className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-sky-400 text-white px-4 py-2 text-sm hover:bg-sky-500 disabled:opacity-50 transition-colors">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Create document
          </button>
        </DialogContent>
      </Dialog>
    </>
  );
}
